<div class="shipments">
  <app-utils-tabs [type]="'Shipments'"></app-utils-tabs>
</div>
